module.exports = __webpack_public_path__ + "img/commander.f789b102.png";